module.exports = __webpack_public_path__ + "static/media/filtros-resultados-loader-mobile.4c2eceda.gif";